/**
 * 원형 칩(편제)은 연간시간표만으로 그려지지만, 미니모달 단원·학습내용은
 * scoped / 진도셀 / 고정행사 행이 있어야 한다.
 */
export function dashboardLessonTermContentNeedsWarmFromFlags(flags: {
  timetableFound: boolean;
  scopedFound: boolean;
  progressFound: boolean;
  progressCoverage: 'full' | 'partial';
  fixedFound: boolean;
}): boolean {
  return (
    !flags.timetableFound ||
    !flags.scopedFound ||
    !flags.progressFound ||
    flags.progressCoverage === 'partial' ||
    !flags.fixedFound
  );
}
